module.exports = __webpack_public_path__ + "d7ba8536ae0a1a483d22ac61aaeb2aa3.png";